import axios from 'axios';
import { setInterceptorsWithReauth, setInterceptors } from '@/api/common/interceptors';

function createInstance(url) {
    return axios.create({
        baseURL: url,
    });
}

function createInstanceWithAuth(url) {
    const instance = axios.create({
        baseURL: url,
    });

    return setInterceptors(instance);
}

function createMultiPartInstanceWithAuth(url) {
    const instance = axios.create({
        baseURL: url,
        headers: { "Content-Type": "multipart/form-data" },
    });

    return setInterceptors(instance);
}

function createBlobResponseInstanceWithAuth(url) {
    const instance = axios.create({
        baseURL: url,
        responseType: "blob",
    });

    return setInterceptors(instance);
}

function createInstanceWithReauth(url) {
    const instance = axios.create({
        baseURL: url,
    });
    return setInterceptorsWithReauth(instance);
}

export const instance = createInstance(process.env.VUE_APP_API_URL);
export const instanceWithAuth = createInstanceWithAuth(process.env.VUE_APP_API_URL);
export const multipartInstanceWithAuth = createMultiPartInstanceWithAuth(process.env.VUE_APP_API_URL);
export const blobResponseInstanceWithAuth = createBlobResponseInstanceWithAuth(process.env.VUE_APP_API_URL);
export const instanceWithReauth = createInstanceWithReauth(process.env.VUE_APP_API_URL);